import { NumberPlateViewComponent } from '@blcloud/bl-ng-ui-component';

/** 検索数(初期表示100件) */
export const SELECT_INIT_SIZE = 100;

/** 検索数(最大表示500件) */
export const SELECT_MAX_SIZE = 500;

/**
 * 顧客・車両情報の候補のグリッド列の設定
 */
export const ColumnDefs = [
  {
    headerName: 'お客様名',
    field: 'customerName',
    minWidth: 140,
  },
  {
    headerName: 'フリガナ',
    field: 'customerKanaName',
    minWidth: 140,
  },
  {
    headerName: '連絡先',
    field: 'contactTelInformation',
    minWidth: 140,
  },
  {
    headerName: 'メールアドレス',
    field: 'contactEmailInformation',
    minWidth: 140,
  },
  {
    headerName: '車両登録番号',
    field: 'dispNumberPlate',
    minWidth: 140,
    cellRendererFramework: NumberPlateViewComponent,
  },
  {
    headerName: 'メーカー ／ 車種',
    field: 'vehicleName',
    minWidth: 140,
  },
  {
    headerName: '顧客コード',
    field: 'customerCode',
    hide: true  // 非表示
  },
  {
    headerName: '車両管理番号',
    field: 'vehicleMgtNumber',
    hide: true  // 非表示
  },
];

/**
 * SNS見込客紐付種別
 */
export enum SnsPotentialCustomerLinkActionType {
  Link,
  Unlink
}

/** Web予約顧客車両紐付け機能名 */
export const WebReserveCustomerVehicleLinkFunctionName = 'Web予約確定';



// WEBPACK FOOTER //
// ./src/app/feature/web-reserve-customer-vehicle-link/web-reserve-customer-vehicle-link.define.ts